const translations = {
    'buildings.actions': 'Akcje',
    'buildings.label.blacksmith': 'Kowal',
    'buildings.label.barracks': 'Koszary',
    'buildings.label.caravanPost': 'Posterunek karawan',
    'buildings.label.charcoalPit': 'Węgielnia',
    'buildings.label.farm': 'Farma',
    'buildings.label.fishingHut': 'Chata rybacka',
    'buildings.label.goldMine': 'Kopalnia złota',
    'buildings.label.house': 'Dom',
    'buildings.label.stoneHouse': 'Kamienny dom',
    'buildings.label.huntingHut': 'Chata myśliwska',
    'buildings.label.ironMine': 'Kopalnia żelaza',
    'buildings.label.lumberjackCamp': 'Obóz drwali',
    'buildings.label.masonry': 'Cegielnia',
    'buildings.label.mint': 'Mennica',
    'buildings.label.stable': 'Stajnia',
    'buildings.label.quarry': 'Kamieniołom',
    'buildings.label.sawmill': 'Tartak',
    'buildings.label.smelter': 'Huta',
    'buildings.label.smokehouse': 'Wędzarnia',
    'buildings.label.weaver': 'Tkacz',
    'buildings.list.blacksmith': '- Kowale: %d',
    'buildings.list.caravanPost': '- Posterunki karawan: %d',
    'buildings.list.charcoalPit': '- Węgielnia: %d',
    'buildings.list.farm': '- Farmy: %d',
    'buildings.list.fishingHut': '- Chaty rybackie: %d',
    'buildings.list.goldMine': '- Kopalnie złota: %d',
    'buildings.list.houses': '- Domy: %d',
    'buildings.list.stoneHouses': '- Kamienne domy: %d',
    'buildings.list.huntingHut': '- Chaty myśliwskie: %d',
    'buildings.list.ironMine': '- Kopalnia żelaza: %d',
    'buildings.list.lumberjack': '- Obóz drwali: %d',
    'buildings.list.masonry': '- Cegielnia: %d',
    'buildings.list.mint': '- Mennice: %d',
    'buildings.list.quarry': '- Kamieniołom: %d',
    'buildings.list.sawmill': '- Tartak: %d',
    'buildings.list.smelter': '- Huta: %d',
    'buildings.list.smokehouse': '- Wędzarnie: %d',
    'buildings.list.storage': '- Magazyn',
    'buildings.list.stable': '- Stajnie: %d',
    'buildings.list.weaver': '- Tkacze: %d',
    'buildings.region': 'Zasoby regionu',
    'buildings.section': 'Budynki',
    'buildings.slots': 'Miejsca: %d/%d',
    'buildings.storage': 'Magazyn',
    'construction.none': 'Brak rozpoczętych budów',
    'construction.section': 'Budowa',
    'nature.section': 'Zasoby regionu',
    'region.fish': 'ryby %d',
    'region.gold': 'złoto %d',
    'region.goldDeposit': 'złoże złota %d',
    'region.ironDeposit': 'złoże żelaza %d',
    'region.stone': 'kamień %d',
    'region.stoneDeposit': 'złoże kamienia %d',
    'region.trees': 'drzewa %d',
    'region.wildlife': 'dzika zwierzyna %d',
    'storage.line1': 'żywność %d • narzędzia %d',
    'storage.line2': 'deski %d • drewno %d',
};

export default translations;
